<div class="sidenav text-center">
  <div class="login-main-text">
    <h2>
      <img src="/assets/images/logo-dark.png" alt="ICX"> <br>
      ICX</h2>
    <h3></h3>
    <p>Effettua il login</p>
  </div>
</div>
<div class="main">
  <div class="col-md-12 col-sm-12 col-lg-8">
    <div class="login-form">
      <h2 class="ml-2 mt-2">Accedi</h2>
      <form [formGroup]="UserData" (ngSubmit)="onSubmit()" #f="ngForm">
        <div class="form-group">
          <input formControlName="email" type="email" class="form-control rounded-pill" name="inputEmail" id="inputEmail" placeholder="Inserisci la tua email" required email>
        </div>
        <div class="form-group">
          <input formControlName="password" type="password" class="form-control rounded-pill" name="inputPass" id="inputPass" placeholder="Inserisci la password"  required>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-md-12">
              <div class="custom-control custom-checkbox mb-2 mr-sm-2 mb-sm-0">
                <input type="checkbox" class="custom-control-input" id="remember" formControlName="remember">
                <label class="custom-control-label float-left font-small pt-1" for="remember">Ricordami su questo computer</label>
              </div>
            </div>
          </div>
        </div>
        <p *ngIf="message" class="text-danger">{{message}}</p>
        <button type="submit" class="btn btn-primary rounded-pill" [disabled]="!f.valid">Entra nel sito</button>
        <a [routerLink]="['/auth/recupera-password']"><small class="ml-5 d-inline-block">Hai dimenticato la password?</small></a>
      </form>

    </div>
  </div>
</div>
